import * as yup from 'yup'
import { IntlShape } from 'react-intl'

import { offerSettingsSchema } from '../NewServicesV2/components/OfferSettingsCard/schema'
import { settingsFormSchema } from '../NewServicesV2/components/SettingsForm/schema'
import { servicesFormSchema } from '../NewServicesV2/components/ServicesForm/schema'
import { IOfferSettingsForm } from 'features/Services/components/NewServicesV2/components/OfferSettingsCard/types'
import { IServicesForm } from 'features/Services/components/NewServicesV2/components/ServicesForm/types'
import { ISettingsForm } from 'features/Services/components/NewServicesV2/components/SettingsForm/types'
import { getPeakSettingsSchema } from 'features/Services/components/PeakSettings/schema'

interface IEditServiceFormSchema extends IOfferSettingsForm, IServicesForm, ISettingsForm {}

export const editServicesSchema = (
  intl: IntlShape,
  { isEndDateOptional }: { isEndDateOptional: boolean }
): yup.SchemaOf<IEditServiceFormSchema> => {
  return yup.object().shape({
    company: yup.object(),
    id: yup.string().required(),
    companyId: yup.string().required(),
    code: yup.string().required(),
    createdAt: yup.date().required(),
    createdBy: yup.string().required(),
    isActive: yup.boolean().required(),
    stops: yup
      .array(
        yup.object({
          id: yup.string().required(),
          name: yup.string().required()
        })
      )
      .required(),
    ...offerSettingsSchema(intl).fields,
    ...servicesFormSchema(intl, { skipCodeVerification: true, isEndDateOptional }).fields,
    ...settingsFormSchema(intl).fields,
    ...getPeakSettingsSchema(intl).fields
  })
}
